export default __webpack_public_path__ + "static/media/mv.fa541791.svg";